<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="how-to-use-this-book">
<h1>How to Use This Book</h1>
<p>This book consists of twenty chapters broken down into three areas. We begin the journey with ‘Discovery’ <em>–</em> focusing on the discovery of one’s self, potential, purpose, and the understanding of foundational principles essential for success. Part II – ‘Succeed’ <em>–</em> focuses on the how-to and the mindset required for actualising success. And lastly, ‘Perennial Success’ focuses on the skills and habits that create meaningful, durable success. With this book, I hope to help you predict and maximise your success.</p>
<p>I encourage you to read the chapters in order, particularly Part I, as it deals with belief systems and sets the pace for other chapters. If you choose not to, perhaps because you want to dive into a specific chapter that speaks to you, that is also fine.</p>
<p>All the chapters have been carefully written in a straightforward, clear, and readable manner, portraying simple, applicable principles that can generate success. These principles are drawn from a wide variety of sources such as medical science, motivational philosophies, traditional wisdom, entrepreneurial habits, etc.</p>
<p>Each chapter is garnished with exciting and beautifully told stories from real-life people, as well as anecdotes, and they end with a realistic call to action to encourage you to use what you learn. Feel free to add more action points of your own. Finally, don’t hesitate to re-read this book as often as possible. Repetition is crucial when learning new skills and conditioning the mind.</p>
<p>Now, let’s get started!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4039f528